'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var utils = require('./utils');

var Plugin = require('./plugin');

module.exports = function (_Plugin) {
  _inherits(Bounce, _Plugin);
  /**
   * @private
   * @param {Viewport} parent
   * @param {object} [options]
   * @param {string} [options.sides=all] all, horizontal, vertical, or combination of top, bottom, right, left (e.g., 'top-bottom-right')
   * @param {number} [options.friction=0.5] friction to apply to decelerate if active
   * @param {number} [options.time=150] time in ms to finish bounce
   * @param {string|function} [ease=easeInOutSine] ease function or name (see http://easings.net/ for supported names)
   * @param {string} [options.underflow=center] (top/bottom/center and left/right/center, or center) where to place world if too small for screen
   * @fires bounce-start-x
   * @fires bounce.end-x
   * @fires bounce-start-y
   * @fires bounce-end-y
   */


  function Bounce(parent, options) {
    _classCallCheck(this, Bounce);

    var _this = _possibleConstructorReturn(this, (Bounce.__proto__ || Object.getPrototypeOf(Bounce)).call(this, parent));

    options = options || {};
    _this.time = options.time || 150;
    _this.ease = utils.ease(options.ease, 'easeInOutSine');
    _this.friction = options.friction || 0.5;
    options.sides = options.sides || 'all';

    if (options.sides) {
      if (options.sides === 'all') {
        _this.top = _this.bottom = _this.left = _this.right = true;
      } else if (options.sides === 'horizontal') {
        _this.right = _this.left = true;
      } else if (options.sides === 'vertical') {
        _this.top = _this.bottom = true;
      } else {
        _this.top = options.sides.indexOf('top') !== -1;
        _this.bottom = options.sides.indexOf('bottom') !== -1;
        _this.left = options.sides.indexOf('left') !== -1;
        _this.right = options.sides.indexOf('right') !== -1;
      }
    }

    _this.parseUnderflow(options.underflow || 'center');

    _this.last = {};

    _this.reset();

    return _this;
  }

  _createClass(Bounce, [{
    key: 'parseUnderflow',
    value: function parseUnderflow(clamp) {
      clamp = clamp.toLowerCase();

      if (clamp === 'center') {
        this.underflowX = 0;
        this.underflowY = 0;
      } else {
        this.underflowX = clamp.indexOf('left') !== -1 ? -1 : clamp.indexOf('right') !== -1 ? 1 : 0;
        this.underflowY = clamp.indexOf('top') !== -1 ? -1 : clamp.indexOf('bottom') !== -1 ? 1 : 0;
      }
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this.toX !== null || this.toY !== null;
    }
  }, {
    key: 'down',
    value: function down() {
      this.toX = this.toY = null;
    }
  }, {
    key: 'up',
    value: function up() {
      this.bounce();
    }
  }, {
    key: 'update',
    value: function update(elapsed) {
      if (this.paused) {
        return;
      }

      this.bounce();

      if (this.toX) {
        var toX = this.toX;
        toX.time += elapsed;
        this.parent.emit('moved', {
          viewport: this.parent,
          type: 'bounce-x'
        });

        if (toX.time >= this.time) {
          this.parent.x = toX.end;
          this.toX = null;
          this.parent.emit('bounce-x-end', this.parent);
        } else {
          this.parent.x = this.ease(toX.time, toX.start, toX.delta, this.time);
        }
      }

      if (this.toY) {
        var toY = this.toY;
        toY.time += elapsed;
        this.parent.emit('moved', {
          viewport: this.parent,
          type: 'bounce-y'
        });

        if (toY.time >= this.time) {
          this.parent.y = toY.end;
          this.toY = null;
          this.parent.emit('bounce-y-end', this.parent);
        } else {
          this.parent.y = this.ease(toY.time, toY.start, toY.delta, this.time);
        }
      }
    }
  }, {
    key: 'calcUnderflowX',
    value: function calcUnderflowX() {
      var x = void 0;

      switch (this.underflowX) {
        case -1:
          x = 0;
          break;

        case 1:
          x = this.parent.screenWidth - this.parent.screenWorldWidth;
          break;

        default:
          x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
      }

      return x;
    }
  }, {
    key: 'calcUnderflowY',
    value: function calcUnderflowY() {
      var y = void 0;

      switch (this.underflowY) {
        case -1:
          y = 0;
          break;

        case 1:
          y = this.parent.screenHeight - this.parent.screenWorldHeight;
          break;

        default:
          y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
      }

      return y;
    }
  }, {
    key: 'bounce',
    value: function bounce() {
      if (this.paused) {
        return;
      }

      var oob = void 0;
      var decelerate = this.parent.plugins['decelerate'];

      if (decelerate && (decelerate.x || decelerate.y)) {
        if (decelerate.x && decelerate.percentChangeX === decelerate.friction || decelerate.y && decelerate.percentChangeY === decelerate.friction) {
          oob = this.parent.OOB();

          if (oob.left && this.left || oob.right && this.right) {
            decelerate.percentChangeX = this.friction;
          }

          if (oob.top && this.top || oob.bottom && this.bottom) {
            decelerate.percentChangeY = this.friction;
          }
        }
      }

      var drag = this.parent.plugins['drag'] || {};
      var pinch = this.parent.plugins['pinch'] || {};
      decelerate = decelerate || {};

      if (!drag.active && !pinch.active && (!this.toX || !this.toY) && (!decelerate.x || !decelerate.y)) {
        oob = oob || this.parent.OOB();
        var point = oob.cornerPoint;

        if (!this.toX && !decelerate.x) {
          var x = null;

          if (oob.left && this.left) {
            x = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : 0;
          } else if (oob.right && this.right) {
            x = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -point.x;
          }

          if (x !== null && this.parent.x !== x) {
            this.toX = {
              time: 0,
              start: this.parent.x,
              delta: x - this.parent.x,
              end: x
            };
            this.parent.emit('bounce-x-start', this.parent);
          }
        }

        if (!this.toY && !decelerate.y) {
          var y = null;

          if (oob.top && this.top) {
            y = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : 0;
          } else if (oob.bottom && this.bottom) {
            y = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -point.y;
          }

          if (y !== null && this.parent.y !== y) {
            this.toY = {
              time: 0,
              start: this.parent.y,
              delta: y - this.parent.y,
              end: y
            };
            this.parent.emit('bounce-y-start', this.parent);
          }
        }
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.toX = this.toY = null;
    }
  }]);

  return Bounce;
}(Plugin);